<template>
  <v-dialog
    v-model="opened"
    content-class="appeal-dialog"
    max-width="400"
    persistent
  >
    <h3 class="appeal-dialog__title">
      {{ $t('appeals.add_appeal') }}
    </h3>

    <v-btn class="close-btn" icon @click="opened = false">
      <v-icon size="27" color="#464646"> mdi-close-circle-outline </v-icon>
    </v-btn>

    <v-form
      ref="appeal-dialog"
      @submit.prevent="onCreate()"
    >
     <v-select
        v-model="car_id"
        outlined
        dense
        item-text="number"
        item-value="id"
        :label="$t('notification.auto.label')"
        :items="filteredCars"
        :loading="carsLoading"
      />
      <v-select
        v-model="category"
        outlined
        dense
        item-text="name"
        item-value="id"
        :items="categories"
        :label="$t('appeals.category')"
        :loading="categoriesLoading"
        :rules="[isRequired]"
      />
      <v-textarea
        v-model="appeal"
        height="100"
        outlined
        dense
        no-resize
        :disabled="loading"
        :label="$t('appealInfo.title')"
        :rules="[isRequired]"
      />

      <v-btn
        type="submit"
        color="warning"
        block
        elevation="0"
        :loading="loading"
      >
        {{ $t('common.button.add') }}
      </v-btn>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    item: {
      type: [Object, null],
      default: null,
    },
  },
  data: () => ({
    loading: false,
    car_id: 0,
    appeal: '',
    carsLoading: false,
    categoriesLoading: false,
    category: '',
  }),
  watch: {
    opened(val) {
      if (!val) {
        this.$refs['appeal-dialog'].reset();
        this.loading = false;
        setTimeout(() => this.$emit('closed'), 300);
      }
    },
  },
  computed: {
    ...mapState({
      cars: ({ appeals }) => appeals.cars,
      categories: ({ appeals }) => appeals.categories,
    }),
    opened: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('change', val);
      },
    },
    filteredCars() {
      return this.cars.filter(({ id }) => Number(id) !== 0);
    },
  },
  methods: {
    isRequired(v) {
      return !!v || this.$t('common.fields.validation.field.required');
    },
    async onCreate() {
      const isValid = this.$refs['appeal-dialog'].validate();
      
      if (!isValid) return;

      this.loading = true;

      await this.$store.dispatch('appeals/addNew', {
        car_id: this.car_id,
        appeal: this.appeal,
        category: this.category,
      });
      this.loading = false;
      this.opened = false;
      window.location.reload();
    },
  },
      async created() {
        if (!this.cars.length) {
          this.carsLoading = true;
          await this.$store.dispatch('appeals/fetchCars');
          this.carsLoading = false;
        }
        if (!this.categories.length) {
          this.categoriesLoading = true;
          await this.$store.dispatch('appeals/fetchCategories');
          this.categoriesLoading = false;
        }
      },
};
</script>

<style lang="scss">
.appeal-dialog {
  padding: 10px;
  background-color: #fff;

  &__title {
    text-align: center;
    margin-bottom: 20px;
  }
}
</style>
